import { OrderNoteDto } from "./order-note-dto.model";

export class RemoveHoldDto {
    orderIds: number[] = [];
    orderNoteDto: OrderNoteDto = new OrderNoteDto();;
}
